module.exports = __webpack_public_path__ + "img/fourday_ps_14.c6382bd1.jpg";